import { jsx as t } from "react/jsx-runtime";
import o from "react";
import { ErrorHandler as s } from "../components/ErrorHandler/ErrorHandler.js";
class u extends o.Component {
  constructor(r) {
    super(r), this.state = {
      hasError: !1,
      errorTitle: r.errorTitle ? r.errorTitle : "We're sorry, but something went wrong.",
      errorMessage: r.errorMessage ? r.errorMessage : 'Please try again later. If the problem persists please contact us at <a href="#contact-us">our support page</a>.'
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: !0
    };
  }
  componentDidCatch(r, e) {
    console.error("Caught error: ", r), console.error("Error info: ", e);
  }
  render() {
    return this.state.hasError ? /* @__PURE__ */ t(s, { title: this.state.errorTitle, message: this.state.errorMessage }) : this.props.children;
  }
}
export {
  u as GeneralErrorBoundary,
  u as default
};
